import * as React from "react";
const SvgShare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={11}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      d="m7.733.601 4.297 4.565a.316.316 0 0 1-.006.44L7.727 9.903a.316.316 0 0 1-.54-.223V7.082a.14.14 0 0 0-.108-.141c-.515-.11-2.818-.372-6.041 2.693-.232.22-.614.01-.525-.297 1.636-5.685 5.62-5.881 6.5-5.853a.17.17 0 0 0 .175-.167v-2.5c0-.286.35-.424.545-.216Z"
    />
  </svg>
);
export default SvgShare;
